export const apiErrorGeneric = {
  title: 'Uh-Oh',
  description: 'There seems to be a problem. Please refresh the page and try again.',
  image: '/images/nba-components/nba-tile-error.png',
  points: [],
  cta: '',
};
